module.exports = __webpack_public_path__ + "img/profile_ldf.62ee4403.jpg";